import * as schema from 'yup';
import { DefinePasswordFormModel } from '../models/models';
import { PASSWORD_POLICY_REGEX } from "@/common/utils/regex";

/* eslint-disable */
export const formSchema = schema.object<
  Partial<Record<keyof DefinePasswordFormModel, schema.AnySchema>>
>({
  password: schema
    .string()
    .required('general.mandatory_field')
    // 1. Length 14-16
    .matches(
      PASSWORD_POLICY_REGEX.MIN_LENGTH, 
      'authentication.password_policy_length'
    )
    // 2. At least one Uppercase
    .matches(
      PASSWORD_POLICY_REGEX.UPPERCASE, 
      'authentication.password_policy_uppercase'
    )
    // 3. At least one Lowercase
    .matches(
      PASSWORD_POLICY_REGEX.LOWERCASE, 
      'authentication.password_policy_lowercase'
    )
    // 4. At least one Number
    .matches(
      PASSWORD_POLICY_REGEX.NUMBER, 
      'authentication.password_policy_number'
    )
    // 5. At least one special char (!@$#%&)
    .matches(
      PASSWORD_POLICY_REGEX.SPECIAL_CHAR, 
      'authentication.password_policy_special'
    ),

  repeatPassword: schema
    .string()
    .oneOf([schema.ref('password')], 'authentication.password_not_equal')
    .required('general.mandatory_field'),
});



//previous code
// export const formSchema = schema.object<
// 	Partial<Record<keyof DefinePasswordFormModel, schema.AnySchema>>
// >({
// 	password: schema
// 		.string()
// 		.required('general.mandatory_field')
// 		.matches(
// 			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+~`\-={}[\]:;"'<>,.?/])[A-Za-z\d!@#$%^&*()_+~`\-={}[\]:;"'<>,.?/]{8,}|^$/,
// 			'authentication.password_rule'
// 		),
// 	repeatPassword: schema
// 		.string()
// 		.oneOf([schema.ref('password')], 'authentication.password_not_equal')
// 		.required('general.mandatory_field'),
// });